<template>
  <div class="disable-two-fa-component">
    <div class="col-12 col-sm-12 col-md-12">
      <h1 class="page-header">{{ user.name || '' }} <small> {{ user.email || '' }}  </small></h1>
    </div>
    <div class="col-12 col-sm-12 col-md-12">
      <form class="margin-bottom-0" @submit.prevent>
          <div class="ct-disable2fa-default">
            <div class="row">

              <div class="col-12 col-sm-6">
                <div class="ct-form-group">
                  <label for="code">{{ $t('disable2FA.codeLabel') }}</label>
                  <input
                    autocomplete="off"
                    class="form-control"
                    :class="{'is-invalid': errors.has('code')}"
                    id="code"
                    name="code"
                    v-validate="{ required: true }"
                    :data-vv-as="$t('disable2FA.code')"
                    type="text"
                    v-model="code"
                  />
                  <div class="invalid-feedback">{{ errors.first('code') }}</div>
                </div>
              </div>
            </div>
            <br>
            <br>
            <div class="row">
              <div class="col-12 col-sm-6">

              </div>
              <div class="col-12 col-sm-6">
                <div class="form-group pull-right form-inline">
                  <button
                    class="btn btn-default btn-lg"
                    type="submit"
                    @click="cancel"
                  >{{$t('disable2FA.cancel')}}</button>
                  <button
                    class="btn btn-primary btn-lg"
                    type="submit"
                    @click="save"
                    :disabled="isLoading"
                  >
                    <i class="fas fa-spinner fa-pulse" v-if="isLoading"></i>
                    {{ $t('disable2FA.submit') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12">
                <div class="alert ct-disable2fa-alert">
                  {{ $t('disable2FA.alert') }}
                </div>
              </div>
            </div>
          </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AuthService from '@/services/AuthService';

export default {
  props: {},
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    async save () {
      if (this.isLoading) return;

      try {
        const isValid = await this.$validator.validate();

        if (!isValid) {
          this.showErroMessage();
          return;
        }

        this.isLoading = true;

        const response = await AuthService.disable2fa(this.code);
        if (response) {
          this.$notify({
            type: 'success',
            title: this.$t('disable2FA.notificationSuccessTitle'),
            text: this.$t('disable2FA.notificationSuccessMessage'),
          });
          this.$emit('finished', response);
          return;
        }
        this.showErroMessage();
      } catch (e) {
        this.isLoading = false;
        this.$notify({
          type: 'error',
          title: this.$t('disable2FA.notificationErrorTitle'),
          text:
            e.response.data.message ||
            e.message ||
            this.$t('disable2FA.notificationErrorMessage'),
        });
      }
    },
    showErroMessage () {
      this.$notify({
        type: 'error',
        title: this.$t('disable2FA.notificationErrorTitle'),
        text: this.$t('disable2FA.notificationErrorMessage'),
      });
      this.isLoading = false;
    },
  },
  data () {
    return {
      isLoading: false,
      code: '',
    };
  },
};
</script>
<style scoped lang="scss">
.disable-two-fa-component {
  .img-fluid {
    min-width: 220px;
    border: #fafafa 1px solid;
    border-radius: 5px;
  }
  h5 {
    small {
      font-weight: 600;
      font-size: 14px;
    }
  }
  .ct-disable2fa-alert {
    background-color: #eff3f4;
    border-color: #eff3f4;
    margin-top: 10px;
  }
}
</style>
